var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 12.6458C7.88792 12.6458 6.17 11.5217 5.315 9.875H9.875V8.29167H4.7925C4.75292 8.03042 4.72917 7.76917 4.72917 7.5C4.72917 7.23083 4.75292 6.96958 4.7925 6.70833H9.875V5.125H5.315C6.17 3.47833 7.89583 2.35417 9.875 2.35417C11.1496 2.35417 12.3212 2.82125 13.2238 3.59708L14.625 2.19583C13.3663 1.06375 11.6958 0.375 9.875 0.375C6.77167 0.375 4.14333 2.36208 3.16167 5.125H0.375V6.70833H2.7975C2.76583 6.96958 2.75 7.23083 2.75 7.5C2.75 7.76917 2.76583 8.03042 2.7975 8.29167H0.375V9.875H3.16167C4.14333 12.6379 6.77167 14.625 9.875 14.625C11.7037 14.625 13.3663 13.9363 14.625 12.8042L13.2158 11.4029C12.3212 12.1788 11.1575 12.6458 9.875 12.6458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvested);
export default __webpack_public_path__ + "static/media/Invested.342bc406a5d534c1a867cf111de36850.svg";
export { ForwardRef as ReactComponent };